// extracted by mini-css-extract-plugin
export default {"Mockup__buttonWrap":"Mockup_Mockup__buttonWrap__DVkSR","Mockup__button":"Mockup_Mockup__button__rfRmT","Guide__img":"Mockup_Guide__img__oSekV"};